import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="text-field"
export default class extends Controller {
  #isHyperfocused = false;

  connect() {
    this.#isHyperfocused = this.element.value.length > 0;

    this.element.addEventListener("input", this.#triggerHyperfocusEvent);
    this.element.addEventListener("blur", this.#triggerHypofocusEvent);
  }

  disconnect() {
    this.element.removeEventListener("input", this.#triggerHyperfocusEvent);
    this.element.removeEventListener("blur", this.#triggerHypofocusEvent);
  }

  #triggerHyperfocusEvent = (event) => {
    if (!this.#isHyperfocused && event.target.value.length > 0) {
      this.#isHyperfocused = true;
      this.dispatch("hyperfocus");
    }
  }

  #triggerHypofocusEvent = (event) => {
    if (this.#isHyperfocused && event.target.value.length === 0) {
      this.#isHyperfocused = false;
      this.dispatch("hypofocus");
    }
  }
}
